import src from "IMAGE";
export default { src, width: 1920, height: 1080, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAARUlEQVR42lXJuw3AMAgEUNgCsRE0iCaCEbJIFkiVbYOusf2q+xCBqr4wgXbd/UBVHYe7f2BmxyEiN0xYKzNn5gURMXXGH3+JFYUU/qprAAAAAElFTkSuQmCC"};
